<template>
  <ImageWrapper :src="src" alt="" />
</template>

<script>
import { ImageWrapper } from "~/components/";

export default {
  name: "Icons",
  components: {
    ImageWrapper,
  },
  props: {
    name: {
      type: String,
    },
  },
  computed: {
    /**
     * Generates the relative path for the icon image
     * @returns {String} The relative path to the icon image
     */
    src() {
      return `/vertuo_pop/assets/images/icon_${this.name}.png`;
    },
  },
};
</script>
